import React, { useMemo, memo } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import ReportMustHaveFilterList from '../report-must-have-filter-list/ReportMustHaveFilterList';
import {
  createReportFieldKey,
  insertSorted,
  toLowerCaseFirstLetter,
} from '../../../util';
import { useIsFrs102Enabled } from '../../../util/hooks/useIsFrs102Enabled';
import { replaceIfrsLabels } from '../../../util/frs102Helper';

interface ReportIncludedFieldsProps {
  reportSnapshot: ReportSnapshot;
}

function ReportIncludedFields({
  reportSnapshot,
}: ReportIncludedFieldsProps): JSX.Element {
  const isFrs102Enabled = useIsFrs102Enabled();
  const { includedFields, resultConfiguration, clientId } = reportSnapshot;

  const renderedIncludedFields = useMemo(() => {
    const fieldComparer = (field1, field2): number =>
      resultConfiguration[
        toLowerCaseFirstLetter(field1.reportPossibleField.fieldName)
      ]?.order -
      resultConfiguration[
        toLowerCaseFirstLetter(field2.reportPossibleField.fieldName)
      ]?.order;
    const fields = includedFields.reduce((acc, field) => {
      if (!field.reportPossibleField?.id) return acc;
      insertSorted(acc, field, fieldComparer);
      return acc;
    }, []);

    return fields.map((field) => (
      <React.Fragment key={createReportFieldKey(field.reportPossibleField)}>
        <GStyled.Text>{replaceIfrsLabels(field.reportPossibleField.fieldName, isFrs102Enabled)}</GStyled.Text>
        <ReportMustHaveFilterList
          clientId={clientId}
          reportField={field.reportPossibleField}
          reportMustHaveFieldFilters={field.reportMustHaveFieldFilters}
        />
        <hr />
      </React.Fragment>
    ));
  }, [clientId, includedFields, isFrs102Enabled, resultConfiguration]);

  return (
    <Styled.ReportIncludedFields>
      {renderedIncludedFields}
    </Styled.ReportIncludedFields>
  );
}

export default memo(ReportIncludedFields);
